/**
 * 同浏览器localStorage监听通信
 */
export function getMsg(type, payload) {
  let data = localStorage.getItem('@ys' + type);
  if (data) {
    return JSON.parse(data)
  }
  return ''
}

export function sendMsg(type, payload, from='') {
  localStorage.setItem('@ys' + type, JSON.stringify({
    from,
    payload,
    temp: Date.now()
  }))
}

export function listenMsg(handler) {
  const storageHandler = (e) => {
    const data = JSON.parse(e.newValue);
    handler(e.key.substring(3), data)
  }
  window.addEventListener('storage', storageHandler)

  return () => {
    window.removeEventListener('storage', storageHandler)
  }
}
